var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceiptCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33325 10.5L11.3333 12.5L15.8333 8M20.3333 21V7.8C20.3333 6.11984 20.3333 5.27976 20.0063 4.63803C19.7187 4.07354 19.2597 3.6146 18.6952 3.32698C18.0535 3 17.2134 3 15.5333 3H9.13325C7.45309 3 6.61302 3 5.97128 3.32698C5.40679 3.6146 4.94785 4.07354 4.66023 4.63803C4.33325 5.27976 4.33325 6.11984 4.33325 7.8V21L7.08325 19L9.58325 21L12.3333 19L15.0833 21L17.5833 19L20.3333 21Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptCheck);
export default __webpack_public_path__ + "static/media/receipt-check.7dad27f62f0d587e6e165fafe2fbf69c.svg";
export { ForwardRef as ReactComponent };